import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import PropTypes from "prop-types";
import api from "../../../../api";
import MediaInfoForm from "./mediaInfoForm";

class MediaInfoCreateButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      creating: false,
      errors: {}
    }

    this.form = React.createRef();
  }

  reportCreate(e, data) {
    e.preventDefault();
    this.setState({creating: true});

    api.mediaInfo.post.report({
      data: data.report
    }).then(() => {
      this.props.handleChange();
      this.setState({
        creating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        creating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { creating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.reportCreateButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <MediaInfoForm errors={errors} onSubmit={this.reportCreate} ref={this.form}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={creating}
            data-style={ZOOM_OUT}
            onClick={e => this.reportCreate(e, this.form.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" onClick={() => this.toggleModal()} className="mb-2"><i className="fas fa-plus" /> <FormattedMessage id="admin.reportCreateButton.button"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

MediaInfoCreateButton.propTypes = {
  handleChange: PropTypes.func.isRequired
};

export default MediaInfoCreateButton;